import React from 'react';
import { func } from 'prop-types';

import { colors, Container, Row, Separator, Typography } from '@ajaibid/components';
import SvgIcon from 'Component/SvgIcon';

import { useStockBuySellContext } from '../../../hooks';
import InputStartDate from './InputStartDate';
import InputEndDate from './InputEndDate';
import InputPriceThreshold from './InputPriceThreshold';
import InputPrice from '../FormLimitOrder/InputPrice';
import InputLotCount from '../FormLimitOrder/InputLotCount';
import InputBtnPercentage from '../FormLimitOrder/InputBtnPercentage';
import SummaryAvailableLot from '../FormLimitOrder/SummaryAvailableLot';
import SummaryTotal from '../FormLimitOrder/SummaryTotal';

const FormAutoOrder = (props) => {
  const { onClickAutoOrderInfo, onClickAvailableLotInfo, onSubmit } = props;

  const { isBuy, isSell } = useStockBuySellContext();

  return (
    <Container padding={0}>
      <Row noGutters marginTop={12} style={{ gap: 4 }}>
        <Typography type="body" bold size="sm" margin={0}>
          {`Syarat ${(isBuy && 'Auto Order Buy') || (isSell && 'Auto Order Sell')}`}
        </Typography>
        <SvgIcon
          name="information"
          height={16}
          width={16}
          color={colors.NEUTRAL_7}
          onClick={onClickAutoOrderInfo}
          data-testid="btn-autoOrderInfo"
        />
      </Row>

      <InputStartDate marginTop={12} />
      <InputEndDate marginTop={12} />
      <InputPriceThreshold marginTop={12} marginBottom={12} />

      <Separator />

      <Row noGutters marginTop={12}>
        <Typography type="body" bold size="sm" margin={0}>
          {`Pengiriman ${(isBuy && 'Auto Order Buy') || (isSell && 'Auto Order Sell')}`}
        </Typography>
      </Row>

      <InputPrice marginTop={12} onSubmit={onSubmit} />
      <InputLotCount marginTop={12} onSubmit={onSubmit} />
      {isBuy && (
        <>
          {/* Note: do not show BtnPercentage on buy */}
          {/* Note: do not show Buying Power on buy */}
          <SummaryTotal marginTop={16} />
        </>
      )}
      {isSell && (
        <>
          <InputBtnPercentage marginTop={8} marginBottom={16} />
          <SummaryAvailableLot onClickAvailableLotInfo={onClickAvailableLotInfo} />
          <SummaryTotal marginTop={12} />
        </>
      )}
    </Container>
  );
};

FormAutoOrder.propTypes = {
  onClickAutoOrderInfo: func,
  onClickAvailableLotInfo: func,
  onSubmit: func,
};

FormAutoOrder.defaultProps = {
  onClickAutoOrderInfo: () => {},
  onClickAvailableLotInfo: () => {},
  onSubmit: () => {},
};

export default FormAutoOrder;
